module.exports = __webpack_public_path__ + "img/pattern1 blue copy 148.6b0df99b.svg";